import SigninCallbackPage from './SigninCallbackPage';

export default SigninCallbackPage;
